import _objectWithoutProperties from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["ext", "key_ops", "alg", "use"];
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
import crypto, { isCryptoKey } from './webcrypto.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { encode as base64url } from './base64url.js';
import { types } from './is_key_like.js';
var keyToJWK = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
    var _yield$crypto$subtle$, ext, key_ops, alg, use, jwk;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(key instanceof Uint8Array)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", {
              kty: 'oct',
              k: base64url(key)
            });
          case 2:
            if (isCryptoKey(key)) {
              _context.next = 4;
              break;
            }
            throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types), ['Uint8Array'])));
          case 4:
            if (key.extractable) {
              _context.next = 6;
              break;
            }
            throw new TypeError('non-extractable CryptoKey cannot be exported as a JWK');
          case 6:
            _context.next = 8;
            return crypto.subtle.exportKey('jwk', key);
          case 8:
            _yield$crypto$subtle$ = _context.sent;
            ext = _yield$crypto$subtle$.ext;
            key_ops = _yield$crypto$subtle$.key_ops;
            alg = _yield$crypto$subtle$.alg;
            use = _yield$crypto$subtle$.use;
            jwk = _objectWithoutProperties(_yield$crypto$subtle$, _excluded);
            return _context.abrupt("return", jwk);
          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function keyToJWK(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default keyToJWK;